import { OpenTofuWorkflowTool } from "types/generated";

/**
 * The OpenTofu workflow tool options to use in a select.
 */
export const OPENTOFU_WORKFLOW_TOOL_OPTIONS = [
  { label: "OpenTofu", value: OpenTofuWorkflowTool.Opentofu },
  { label: "Custom", value: OpenTofuWorkflowTool.Custom },
];
